import { LocationSuggestionTypeCode } from '@abg/typings';

import { GroupLimits } from './suggestion-group.types';

export const DEFAULT_GROUP_PREVIEW_LIMIT = 2;

export const groupPreviewLimitsMapping: Partial<
  Record<LocationSuggestionTypeCode, keyof GroupLimits>
> = {
  CITY_DOWNTOWN: 'amountOfCities',
  'OTR-POINT_OF_INTEREST': 'amountOfPoI',
  AIRPORT: 'amountOfAirports',
  'ABG-AIRPORT': 'amountOfAirports',
  'OTR-CITY': 'amountOfCities',
  NEIGHBOURHOOD: 'amountOfNeighborhoodLocations',
  TRUCK: 'amountOfTruckLocation',
};

export const defaultGroupLimits: Record<keyof GroupLimits, number> = {
  amountOfCities: DEFAULT_GROUP_PREVIEW_LIMIT,
  amountOfPoI: DEFAULT_GROUP_PREVIEW_LIMIT,
  amountOfAirports: DEFAULT_GROUP_PREVIEW_LIMIT,
  amountOfNeighborhoodLocations: DEFAULT_GROUP_PREVIEW_LIMIT,
  amountOfTruckLocation: DEFAULT_GROUP_PREVIEW_LIMIT,
};
